<template>
    <div class="grid items-center grid-cols-12 text-xs bg-white dark:bg-neutral-950">
        <div class="col-span-8 py-2 pl-2">
            {{ instance.name }}
        </div>
        <div class="col-span-2 flex justify-end items-center">
            <Boolean :value="instance.is_active" />
        </div>
        <div class="flex justify-end col-span-2 pr-4">
            <div
                v-if="instance.is_active"
                v-tooltip="{
                    message: instance.is_active
                        ? lang('snap::instances.actions.power_off')
                        : lang('snap::instances.actions.power_on'),
                    placement: 'right',
                }"
                class="relative"
            >
                <Button @click="toggle">
                    <icon icon="hero/outline/power" class="size-4"></icon>
                </Button>
            </div>
            <div
                v-else-if="!instance.is_active"
                v-tooltip="{
                    message: instance.is_active
                        ? lang('snap::instances.actions.power_off')
                        : lang('snap::instances.actions.power_on'),
                    placement: 'right',
                }"
                class="relative"
            >
                <Button @click="toggle">
                    <icon icon="hero/outline/rocket-launch" class="size-4"></icon>
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { Instance } from '@src/Snap/Pages/types';

interface Props {
    instance?: Instance | null;
}

const props = withDefaults(defineProps<Props>(), {
    instance: null,
});

const instance = toRef(props, 'instance');

const toggle = () => {
    if (!instance.value) return;

    axios.post(route('snap/instances.admin.api.power', { id: instance.value.id })).then(({ data }) => {
        instance.value.is_active = data.instance.is_active;
    });
};
</script>
